/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2021 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-media-hdr-xml-asset-selector-component.ts
 *
 * Created by kyang on 3/27/2020.
 */

function PackageMediaHdrXmlAssetSelectorController (
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    DynamicPropertiesService: JS5Object,
    PackageMediaService: JS5Object,
    PackageFileUploadService: JS5Object,
    PackageUtilService: JS5Object,
    TempFileUploadService: JS5Object,
) {
    this.getMainVideo = (): JS5Object => {
        return PackageMediaService.getMainVideo();
    };

    const setHdrXml = (virtualPath: string, isRemoteUploadEnabled: boolean) => {
        let mainVideo = this.getMainVideo();
        mainVideo.pendingIngest = mainVideo.pendingIngest || isRemoteUploadEnabled;
        mainVideo.hdrMetadataAssetId = (mainVideo.hdrMetadataPath) ? -1 : null;
        mainVideo.hdrMetadataPath = virtualPath;
        PackageUtilService.editorForm.$setDirty();
    };


    //================//
    // Template Logic //
    //================//

    this.remoteUploadEnabled = () => {
        return DynamicPropertiesService.getPropValueAsBoolean('mediaTabRemoteUpload.enabled', false);
    }

    this.canIngestHdrXml = () => {
        return PackageMediaService.hasMainVideo();
    };

    this.onViewAssetButtonClick = ($event: JS5Object) => {
        $event.stopImmediatePropagation();
        PackageMediaService.openViewAssetModal(this.getMainVideo(), true);
    };

    this.onCurrentFileChanged = () => {
        PackageFileUploadService.unregisterLocalConfig(this.uploaderConfig);
        if (PackageMediaService.hasMainVideo()) {
            if (_.get(this, 'currentFile.status') === 'PASSED') {
                switch (this.currentFile.type) {
                    case 'ASPERA':
                        setHdrXml(this.currentFile.results[0].uploadedData, true);
                        break;
                    case 'LOCAL':
                        // Display fileName (Correct virtualPath is set when media is saved)
                        PackageFileUploadService.registerLocalConfigForUpload(this.uploaderConfig);
                        setHdrXml(`s3:fakePath/${this.currentFile.files[0].file.name}`, false);
                        break;
                    case 'REMOTE':
                        setHdrXml(this.currentFile.files[0].virtualPath, false);
                        break;
                }
            } else {
                this.getMainVideo().hdrMetadataPath = null;
            }
        }
    };


    //========================//
    // Remote File Validation //
    //========================//

    this.getFileExtensions = () => {
        return ['xml'];
    };

    this.validateRemoteFile = (fileSystemItem: JS5Object) => {
        // XMLs aren't validated
        let virtualPath = fileSystemItem.parent + fileSystemItem.name;
        return $q.when({
            source: virtualPath,
            errors: [],
            warnings: []
        });
    };


    //========================//
    // Aspera File Validation //
    //========================//

    this.validateAsperaFile = (asperaFileObject: JS5Object) => {
        // XMLs aren't validated
        let validationResult: JS5Object = {
            source: asperaFileObject.name,
            errors: [],
            warnings: []
        };
        return PackageFileUploadService.parseAsperaValidationResult(PackageMediaService.packageObject, asperaFileObject, validationResult);
    };


    //=======================//
    // Local File Validation //
    //=======================//

    this.getLocalFilePreValidationErrors = (file: File, filter: JS5Object) => {
        // Doesn't add any local file filters
    };

    this.validateLocalFile = (fileItem: JS5Object, uploaderConfig: JS5Object) => {
        // XMLs aren't validated
        fileItem.onVirtualPathSet = (virtualPath: string) => {
            let mainVideo = this.getMainVideo();
            mainVideo.hdrMetadataPath = virtualPath;
            mainVideo.pendingIngest = true;
        };
        return {
            source: fileItem.file.name,
            errors: [],
            warnings: []
        };
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.prevMainVideo = PackageMediaService.getMainVideo();
    };

    this.initializeLocalUploaderConfig = (uploaderConfig: JS5Object) => {
        TempFileUploadService.initialize(uploaderConfig);
        this.uploaderConfig = uploaderConfig;
    };

    this.$doCheck = () => {
        let mainVideo = PackageMediaService.getMainVideo();
        if (this.uploaderConfig && this.prevMainVideo !== mainVideo) {
            this.currentFile = null;
            this.prevMainVideo = mainVideo;
        }
    };

    this.$onDestroy = () => {
        PackageFileUploadService.unregisterLocalConfig(this.uploaderConfig);
    };
}

angular.module('prism-ui.package').component(
    'packageMediaHdrXmlAssetSelector',
    {
        controller: PackageMediaHdrXmlAssetSelectorController,
        templateUrl: 'package/editor/components/view/media/assetSelector/videoMain/hdrXml/package-media-hdr-xml-asset-selector-template.html',
        bindings: {
        }
    });
